<template>
  <div class="loaddetail">
    <!-- 当前代办 -->
    <div>
      <div class='loaddetail-t mt-0'>当前待办</div>
      <el-table v-if="address_info" :data="address_info" :header-cell-style="{background: '#f9f9f9', color: '#333'}">
        <el-table-column prop label="申请寄样信息">
          <template slot-scope="scope">
            <div class="">
              收货人姓名：{{ scope.row.name ?setEncryption(scope.row.name) : "--" }}
            </div>
            <div>收货人电话：{{ scope.row.tel ? setEncryption(scope.row.tel) : "--" }}</div>
            <div>寄样收货地址：{{ setEncryption(scope.row.address_detail) }}</div>
            <div>需要样品份数 : {{ scope.row.goods_num }}</div>
          </template>
        </el-table-column>
        <el-table-column prop label="寄样情况">
          <template slot-scope="scope">
            <div v-if="scope.row.logistics">
              <div v-if="scope.row.logistics.length > 0">
                <div
                  v-for="(item, index) in scope.row.logistics"
                  :key="index"
                  class="logistics"
                >
                  <div>物流公司：{{ setEncryption(item.express_company) }}</div>
                  <div>物流单号：{{ setEncryption(item.logistics_numbers) }}</div>
                  <div>
                    寄出样品份数：{{
                      item.send_sample_number ? item.send_sample_number : "--"
                    }}
                  </div>
                  <div>
                    物流状态：<span
                      v-if="item.is_received == 1"
                      class="p-warning"
                      >快递在路上</span
                    >
                    <span v-if="item.is_received == 2" class="p-color-succ"
                      >快递已签收</span
                    >
                  </div>
                </div>
              </div>
              <div v-if="scope.row.logistics.length == 0">尚未寄样</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 商品信息 -->
    <div>
      <div class='loaddetail-t'>商品信息</div>
      <el-table :data="goods_info"  :header-cell-style="{background: '#f9f9f9', color: '#333'}">
        <el-table-column label="基本信息" width="90px">
          <template slot-scope="scope">
            <img class="goods-img" :src="scope.row.goods_img" alt="商品图" />
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <div class='goods-name' @click='openUrl(scope.row.goods_link)'>{{ scope.row.goods_name }}</div>
            <div>
              商城：
              <span v-if="scope.row.platform == 'taobao'">淘宝</span>
              <span v-if="scope.row.platform == 'tianmao'">天猫</span>
              <span v-if="scope.row.platform == 'jingdong'">京东</span>
              <span v-if="scope.row.platform == 'suning'">苏宁</span>
              <span v-if="scope.row.platform == 'kaola'">考拉</span>
              <span v-if="scope.row.platform == 'douyin'">抖音小店</span>
              <span v-if="scope.row.platform == 'weipinhui'">唯品会</span>
              <span v-if="scope.row.platform == 'wangyiyanxuan'">网易严选</span>
            </div>
            <div>品牌：{{ scope.row.brand_name }}</div>
            <div>日常售价：￥{{ Number(scope.row.daily_price) }}</div>
            <div>商品ID：{{ scope.row.goods_id }}</div>
            <div>店铺：{{ scope.row.store_name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="合作信息">
          <template slot-scope="scope">
            <div>可供样品数：{{ scope.row.sample_number }}</div>
            <div>
              样品是否需要寄回：{{
                scope.row.is_retrieve_sample == 1 ? "否" : "是"
              }}
            </div>
            <div>达人专属价：{{ Number(scope.row.kol_special_price) }}元</div>
            <div>
              折扣方式：
              <span v-if="scope.row.discount_model == 2">直降</span>
              <span v-if="scope.row.discount_model == 3">满减</span>
              <span v-if="scope.row.discount_model == 4">优惠券</span>
              <span v-if="scope.row.discount_model == 5">优惠券+满减</span>
              (
              <span
                v-if="
                  scope.row.discount_model == 4 || scope.row.discount_model == 5
                "
                >优惠券金额{{ scope.row.coupon_money }}元</span
              >
              <span
                v-if="scope.row.discount_model == 5 && scope.row.coupon_full"
                >，</span
              >
              <span
                v-if="
                  (scope.row.discount_model == 3 ||
                    scope.row.discount_model == 5) &&
                    scope.row.coupon_full
                "
                >满{{ scope.row.coupon_full }}元减{{
                  scope.row.coupon_subtract
                }}元</span
              >）
            </div>
            <div>佣金比例：{{ Number(scope.row.commission_rate) }}%</div>
            <el-tooltip placement="top" v-if="scope.row.specific_benefits.length>18">
              <div slot="content" class="w-300">
                {{ scope.row.specific_benefits }}
              </div>
              <div class="p-text-clamp">
                达人专属福利：{{ scope.row.specific_benefits }}...
              </div>
            </el-tooltip>
            <div v-else>
              <div class="p-text-clamp">
                达人专属福利：{{ scope.row.specific_benefits }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <div>商单预计推广时间：</div>
            <div v-if="cpx_order_info">
              {{ cpx_order_info.expect_begin_time.slice(0, 10) }}至
            </div>
            <div v-if="cpx_order_info">
              {{
                cpx_order_info.expect_end_time &&
                  cpx_order_info.expect_end_time.slice(0, 10)
              }}
            </div>
            <div v-if="scope.row.is_head_coop == 2">
              <div v-if="scope.row.platform == 'douyin'">
                商品实际推广时间：
              </div>
              <div v-else>商品实际团长时间：</div>
              <div v-if="scope.row.reality_begin_time">
                {{ scope.row.reality_begin_time.slice(0, 10) }}至
                <br />
              </div>
              <div>
                {{
                  scope.row.reality_end_time &&
                    scope.row.reality_end_time.slice(0, 10)
                }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 达人信息 -->
    <div>
      <div class='loaddetail-t'>达人信息</div>
      <div class="kol-li">
        <span class="kol-l">昵称：</span>
        {{ kol_info.nickname }}
      </div>
      <div class="kol-li">
        <span class="kol-l">平台：</span>
        {{ kol_info.type_name }}
      </div>
      <div class="kol-li">
        <span class="kol-l">达人主页：</span>
        <el-popover
          v-if='!kol_info.home_link'
          placement="top-start"
          trigger="click"
          content="该达人主页还在完善哦">
          <span class='page-pointer' slot="reference">查看达人主页</span>
        </el-popover>
        <span v-else class='page-pointer' @click="openUrl(kol_info.home_link)">查看达人主页</span>
      </div>

      <div class="kol-li">
        <span class="kol-l">粉丝数：</span>
        {{ kol_info.fans }}
      </div>
      <div class="kol-li">
        <span class="kol-l">是否需要样品：</span>
        <span v-if="deal_info.is_send_samples == 1">需要寄样</span>
        <span v-if="deal_info.is_send_samples == 2">无需寄样</span>
      </div>
      <div class="kol-li">
        <span class="kol-l">推广形式：</span>
        <el-checkbox
          v-if="deal_info.promote_video == 2"
          disabled
          :checked="true"
          >短视频</el-checkbox
        >
        <el-checkbox v-if="deal_info.promote_live == 2" disabled :checked="true"
          >直播混播</el-checkbox
        >
        <el-checkbox
          v-if="deal_info.promote_live_special == 2"
          disabled
          :checked="true"
          >直播专场</el-checkbox
        >
        <el-checkbox
          v-if="deal_info.promote_other == 2"
          disabled
          :checked="true"
          >其他</el-checkbox
        >
      </div>
    </div>
    <!-- 达人采访记录 -->
    <mediaQuestions v-if='media_questions_obj.media_questions_flag'  :media_questions_obj='media_questions_obj'></mediaQuestions>
  </div>
</template>

<script>
import mediaQuestions from '@/components/cpx/media_questions.vue'
export default {
  name: "loaddetail",
  components:{
    mediaQuestions:mediaQuestions
  },
  data() {
    return {
      api:{
        getKaDealDetail:'/home/getKaDealDetail'
      },
      address_info: [
      ],
      goods_info: [
      ],
      cpx_order_info: {
      },
      kol_info: {
      },
      deal_info: {
      },
      media_questions_obj: {
        media_questions_flag: false,
        klurid: ""
      }
    };
  },
  created() {
    // this.kldlid = this.$route.query.kldlid;
    window.scrollTo(0,0)
    this.getKaDealDetail()
  },
  methods: {
    getKaDealDetail(){
      let _this=this;
      let params={
        kldlid:this.$route.query.kldlid
      }
      this.$http({
        method:"GET",
        url:_this.api.getKaDealDetail,
        params:params
      }).then(res=>{
        if(res.code==1){
          _this.goods_info.push(res.data.goods_info);
          _this.cpx_order_info=res.data.cpx_order_info;
          _this.kol_info=res.data.kol_info;
          _this.deal_info=res.data.deal_info;
          _this.address_info=res.data.address_info;
          if(res.data.address_info.length>0){

          }
          // let arr=[];
          // console.log(res.data.goods_info)
          // _this.goods_info=arr.push(res.data.goods_info);
          // // _this.goods_info=arr;
          // console.log(arr)

        }else{
          console.log(res.msg)
        }
      })
    },
    openUrl(link){
      window.open(link)
    },
    goMideaQuestion(){
      this.media_questions_obj.klurid=this.kol_info.klurid||this.deal_info.klurid;
      this.media_questions_obj.media_questions_flag=true;
    },
    setEncryption(data){
      return '*'.repeat(data.length)
    }
  },
};
</script>

<style scoped>
.p-warning {
  color: #f56c6c;
}
.p-color-succ {
  color: #67c23a;
}
.logistics {
  border-bottom: 1px solid #ebeef5;
}
.box-card {
  margin-top: 20px;
}
.goods-img {
  display: block;
  width: 80px;
  height: 80px;
}
.w-300 {
  width: 300px;
}
.p-text-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.kol-li {
  display: flex;
  font-size:14px;
  line-height: 28px;
  align-items: center;
}
.kol-l {
  width: 100px;
  text-align: right;
}
.goods-name{
  cursor: pointer;
  color:#6435E8;
}
.loaddetail-t{
  font-size:20px;
  color: #252328;
  border-left:3px solid #6435E8;
  height:20px;
  line-height:20px;
  text-indent: 15px;
  margin:36px 0 36px -20px;
}
.mt-0{
  margin-top:0px;;
}
</style>

